import { getProductsList } from './tmr-products.js';
import { getProductsTotal } from './tmr-products.js';

export function tmrPurchase(products) {
    return Promise.resolve({
        type: 'itemView',
        productid: getProductsList(products),
        pagetype: 'purchase',
        list: '1',
        totalvalue: getProductsTotal(products)
    });
}